import type { AdminDocsShareLink } from "@/types/docsShareLinks";

export type DocsShareFeedbackSeverity =
  "success" | "error" | "info" | "warning";
export const MAX_DOCS_SHARE_EXPIRY_DAYS = 90;

export const formatDateTime = (value: string | null): string => {
  if (!value) {
    return "—";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString();
};

export const toShareUrl = (token: string): string =>
  `${window.location.origin}/share/docs/${token}`;

export const getStatusChipColor = (
  status: AdminDocsShareLink["status"],
): "success" | "warning" | "default" => {
  if (status === "active") {
    return "success";
  }
  if (status === "expired") {
    return "warning";
  }

  return "default";
};

export const parseExpiryDaysInput = (
  expiresInDays: number | "",
): number | null => {
  if (expiresInDays === "") {
    return null;
  }

  const parsed = Number(expiresInDays);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }

  return Math.min(Math.floor(parsed), MAX_DOCS_SHARE_EXPIRY_DAYS);
};
